var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383",
    transform: "translate(-2187 -481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373",
    transform: "translate(2190.427 484.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M131.885,100.745h12.26a1.963,1.963,0,0,0,1.964-1.963V94.157a.655.655,0,0,0-.654-.655.676.676,0,0,0-.655.655v4.625a.633.633,0,0,1-.654.655h-12.26a.633.633,0,0,1-.655-.655V86.522a.633.633,0,0,1,.655-.655h4.625a.676.676,0,0,0,.654-.655.655.655,0,0,0-.654-.654h-4.625a1.963,1.963,0,0,0-1.963,1.964v12.26a1.963,1.963,0,0,0,1.963,1.963Z",
    transform: "translate(-129.921 -83.591)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M261.216,60.32a1.985,1.985,0,0,0-2.792,0L250.963,67.8l-.524,3.141a1.113,1.113,0,0,0,.284.96,1.179,1.179,0,0,0,.785.305h.175l3.141-.545,7.483-7.461a2.007,2.007,0,0,0,0-2.792Zm-.938.916,1.113,1.113a.655.655,0,0,1,.175.458.7.7,0,0,1-.175.458l-.044.044-2.029-2.029.044-.044a.676.676,0,0,1,.916,0Zm-6.087,9.206-2.421.415.415-2.421,6.2-6.217,2.029,2.029Z",
    transform: "translate(-245.727 -59.746)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 24,
    height: 24,
    transform: "translate(2187 481)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.402d65e4f4a9646e79861cccc67148c1.svg";
export { ForwardRef as ReactComponent };